import http from '@/plugins/http';

// When the request succeeds
const success = (response, onSuccessCallback) => {
  onSuccessCallback(response);
};

// When the request fails
const failed = (error, onFailureCallback) => {
  onFailureCallback(error);
};

export default (token, onSuccessCallback, onFailureCallback) => {
  const data = {};
  http.post(`v3/users/customer-user/auth0/signin?id_token=${token}`, data)
    .then((response) => {
      success(response.data, onSuccessCallback);
    })
    .catch((error) => {
      failed(error, onFailureCallback);
    });
};
